module.exports = __webpack_public_path__ + "static/media/close.b853a1d5.svg";